module.exports = __webpack_public_path__ + "static/media/lobby.642b4382.jpg";